import api from '../../api/api_resource'

// const ALL       = [1,2,3,4,5];
// const ACTIVE    = 1;
// const PREVIEW   = 2;
// const STOCKONLY = 3;
// const BLOCKED   = 4;
// const ARCHIVED  = 5;
const state = {
    ids: [1,2,3,4],
    all: [{
        id: 1, name: 'Active'
    },{
        id: 2, name: 'Preview'
    },{
        id: 3, name: 'Stock Only'
    },{
        id: 4, name: 'Blocked'
    },{
        id: 5, name: 'Archived'
    }],
    current_page: 1,
    per_page: 5,
    from: 1,
    to: 5,
    last_page: null,
    total: null,
};

// getters
const getters = {
    all: (state, getters, rootState) => {
        return state.all;
    },
    ids: (state, getters, rootState) => {
        return state.ids;
    }
};

// actions
const actions = {
    // getUserStatuses({ commit, state }, args) {
    //     return new Promise((success, error) => {
    //         const search_args = Object.assign({
    //             page: state.current_page,
    //             per_page: state.per_page
    //         }, args);
    //         api.index('user-statuses', search_args).then(status => {
    //             commit('setStatus', status);
    //             success(status);
    //         }).catch(error);
    //     });
    // },
};

// mutations
const mutations = {
    setStatus (state, result) {
        state.all = result.data;
        state.current_page = result.current_page;
        state.per_page = parseInt(result.per_page);
        state.from = result.from;
        state.to = result.to;
        state.last_page = result.last_page;
        state.total = result.total;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./resources/js/store/modules/userStatuses.js